import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { FacilityService } from "../../../../../../shared/services/facility.service";
import { DistrictAdministrationService } from "../../../../services/districtadministration.service";

@Component({
	selector: "app-district-school-add-facility",
	templateUrl: "./district-school-add-facility.component.html",
	styleUrls: ["./district-school-add-facility.component.css"],
})
export class DistrictSchoolAddFacilityComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private districtadministrationService: DistrictAdministrationService,
		private dialogConfig: DynamicDialogConfig
	) {}

	ngOnInit(): void {
		//Get Data from DB
		this.loadFacilityList();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	lstFacility: any = [];
	SelectedFacilities: any = [];
	lstActive: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "FacilityName", header: "Facility Name" },
		{ field: "FacilityCD", header: "Facility Code" },
		{ field: "Active", header: "Active" },
	];

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadFacilityList() {
		var result = this.districtadministrationService.FacilityGetList();
		result.subscribe(
			(response) => {
				this.lstFacility = response;

				for (var i = 0; i < this.lstFacility.length; i++) {
					this.lstFacility[i].Active = this.lstFacility[i].Active == 1 ? "Active" : "Inactive";
				}

				this.lstActive = Array.from(new Set(this.lstFacility.map((item: any) => item.Active))).sort();

				this.UpdateSelected();
			},
			(error) => {}
		);
	}

	UpdateSelected() {
		this.SelectedFacilities = this.dialogConfig.data.SelectedFacilities;
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		this.ref.close(this.SelectedFacilities);
	}
	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
